export const ROLE_ANONYMOUS = 'ROLE_ANONYMOUS';
export const ROLE_USER = 'ROLE_USER';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MANAGER = 'ROLE_MANAGER';
export const ROLE_PROJECT_LEADER = 'ROLE_PROJECT_LEADER';
export const ROLE_OPERATOR = 'ROLE_OPERATOR';
export const ROLE_SAV = 'ROLE_SAV';

export const MAP_ROLE = new Map([
    [ROLE_OPERATOR, 'Opérateur'],
    [ROLE_PROJECT_LEADER, 'Chef de projet'],
    [ROLE_MANAGER, 'Gestionnaire'],
    [ROLE_ADMIN, 'Administrateur'],
    [ROLE_SAV, 'SAV'],
]);
